var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{ref:"button",staticClass:"button center uppercase relative px-15 b-box",style:(_vm.styling),attrs:{"disabled":_vm.disabled || _vm.loading,"type":_vm.type}},[_c('pulse-loader',{attrs:{"loading":_vm.load,"color":'var(--green)',"size":"10px"}}),(!_vm.load)?_vm._t("default"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }